import { JoyspacePermissionType } from '../../../config/permissions.config';
import { TabKeyType } from '../../../types';

// export enum TabKeyType {
//     All = 'All',
//     RecentlyContact = 'recentlyContact',
//     Contact = 'user',
//     Department = 'org',
//     Groups = 'group',
// }

export const tab = [
  // { title: '全部', key: TabKeyType.All },
  { title: '最近分享', key: TabKeyType.RecentlyContact },
  { title: '组织架构', key: TabKeyType.Department },
  { title: '虚拟通讯录', key: TabKeyType.WorkLine },
  { title: '我的组', key: TabKeyType.Groups },
  { title: '我的联系人', key: TabKeyType.Contact },
];

export const tabAllList = [
  { title: '全部', key: TabKeyType.All },
  { title: '联系人', key: TabKeyType.Contact },
  { title: '部门', key: TabKeyType.Department },
  { title: '组', key: TabKeyType.Groups },
];

// export const tabAll: { [key: string]: string } = {
//     [TabKeyType.Contact]: '我的联系人',
//     [TabKeyType.Department]: '组织架构',
//     [TabKeyType.Groups]: '我的组',
// };

export interface tabType {
  title: string;
  key: string;
}

export interface IProps {
  id: string;
  checked: boolean;
  avatar: string;
  name: string;
  desc: string;
  type: TabKeyType;
  typeName?: TabKeyType;
  isSelectUser?: boolean;
  isHasGroups?: boolean;
  disabled?: boolean;
  labelInfoList?: any;
  isGroupExternal?: boolean;
  highlight?: any[];
  descHighLight?: any[];
  keyHighLight?: string;
  keyTitleHighLight?: string;
  isShowRightIcon?: boolean;
  activeKey?: TabKeyType;
  callback?: (item: IProps) => void;
}
// 选中数组
export interface SelectType {
  id: string;
  avatar: string;
  name: string;
  desc: string;
  type: string;
  checked?: boolean;
  permissionType: JoyspacePermissionType;
  tenantId?: string;
  teamId?: string;
  userId?: string;
}
